<!--
  - Website: https://www.4myth.com
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Copyright © 2016-2022 All rights reserved.
  - MyTh Ahmed Fayez
  -->

<template>
  <Transition
    appear
    mode="out-in"
    name="slide-fade"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </Transition>
</template>
<script>

export default {
  name: 'SlideFadeTransition'
}
</script>
